import { useEnsureContext } from "@madmedical/utils";
import AppConfigContext from "./AppConfigContext";
export default () => useEnsureContext(AppConfigContext);
